var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0164 32.2406V23.8827H25.6709L41.2443 16.6673L34.0164 32.2406Z",
    fill: "#0C233C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6708 27.4594V35.8174H34.0164L18.443 43.0452L25.6708 27.4594Z",
    fill: "#0C233C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 18.6667C23.684 13.6495 31.2471 12.7056 37.2207 15.86L25.2736 3.91302L3.91309 25.2736L15.8601 37.2206C12.7181 31.2471 13.6495 23.6964 18.6668 18.6667Z",
    fill: "#0C233C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0204 41.0333C36.0032 46.0505 28.4401 46.9944 22.4666 43.8399L34.4136 55.787L55.7741 34.4264L43.8271 22.4794C46.9691 28.4529 46.0377 36.0036 41.0204 41.0333Z",
    fill: "#0C233C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrityIcon);
export default __webpack_public_path__ + "static/media/IntegrityIcon.89b9ec97aef08950da8b997caa4c84d6.svg";
export { ForwardRef as ReactComponent };